import { FC } from 'react';
import { FormattedTime } from 'react-intl';
import styled, { css } from 'styled-components';

import { DiscountPrice } from '@common/components/Price';
import { useTranslations } from '@lang';
import { Discount, Price } from 'shared-types';

const PriceBubble = styled.div`
  float: right;
  padding-left: 20px;
`;

interface ParentComponentProps {
  isSelected: boolean;
  isOption: boolean;
}

const ParentComponent = styled.div<ParentComponentProps>`
  cursor: pointer;
  font-size: 16px;
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  background: ${({ theme, isSelected }) => (isSelected ? theme.customColors.tertiary : 'none')};

  ${({ isOption }) =>
    isOption &&
    css`
      padding: 6px 55px 6px 15px;
    `};
`;

type TimeSlotOptionHOCProps = {
  parentType: 'Option' | 'SingleValue';
  data: {
    startDateTime: string;
    price: Price;
    time: string;
    discount?: Discount;
  };
  isFocused: boolean;
  isSelected: boolean;
  innerProps: any;
  showPerPerson?: boolean;
};

const TimeSlotOptionHOC: FC<TimeSlotOptionHOCProps> = ({
  parentType = 'Option',
  data: { startDateTime, price, discount },
  innerProps,
  isSelected,
  showPerPerson = false,
}) => {
  const isOption = parentType === 'Option';

  const { t } = useTranslations();
  return (
    <ParentComponent {...innerProps} isSelected={isSelected} isOption={isOption}>
      <span>
        <FormattedTime value={startDateTime} hour="numeric" minute="numeric" />
      </span>

      <PriceBubble>
        <DiscountPrice price={price} discount={discount} />{' '}
        {showPerPerson && t('spa.timeslot.perPerson')}
      </PriceBubble>
    </ParentComponent>
  );
};

export default TimeSlotOptionHOC;
